module.exports = require("./fr-SC.d.ts");